(() => {
  const params = new URLSearchParams(location.search);
  const preview = ['preview_theme_id', '_fd', 'pb'].filter(key => params.has(key));
  const update = root => {
    root.querySelectorAll('a[href],summary[data-follow-link]').forEach(link => {
      const attr = link.hasAttribute('href') ? 'href' : 'data-follow-link';
      const value = link.getAttribute(attr);
      if (!value || value.startsWith('#')) return;
      try {
        const url = new URL(value, location.href);
        if (url.origin !== location.origin || !['http:', 'https:'].includes(url.protocol)) return;
        const view = url.searchParams.get('view');
        if (['modulo-kitchens', 'modulo-surfaces'].includes(view) && ['own', 'example'].includes(url.searchParams.get('start'))) {
          url.searchParams.set('view', view === 'modulo-kitchens' ? 'modulo-planner' : 'modulo-worktops');
          url.searchParams.set('example', url.searchParams.get('start') === 'example' ? '1' : '0');
          url.searchParams.delete('start'); url.hash = view === 'modulo-kitchens' ? 'planner' : '';
        }
        preview.forEach(key => url.searchParams.set(key, params.get(key)));
        link.setAttribute(attr, url.pathname + url.search + url.hash);
      } catch {}
    });
  };
  if (params.get('finish') === 'senza-gloss-white') {
    const enquiry = document.querySelector('[name="contact[body]"]');
    if (enquiry && !enquiry.value.trim()) enquiry.value = 'I am interested in Senza Gloss White. Please confirm the correct product list and price for my kitchen.';
  }
  update(document);
  document.addEventListener('shopify:section:load', event => update(event.target));
})();
